import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOData from '@/components/feature/SEOData';

export default function AboutPage() {
  return (
    <>
      <SEOData
        pageTitle="关于我们 - 妈妈的朋友在线观看·完整版高清免费播放"
        pageDescription="了解妈妈的朋友影视平台 - 专业的影视资讯与影评分享平台。品牌介绍、用户口碑、联系方式，致力于为影视爱好者提供高质量的观影指南。"
        canonicalPath="/about"
        pageType="about"
        breadcrumbs={[
          { name: '首页', url: 'https://mamadepengyou.com' },
          { name: '关于我们', url: 'https://mamadepengyou.com/about' },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs" />
              <span className="text-foreground-800">关于我们</span>
            </nav>

            <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-6">
              关于妈妈的朋友
            </h1>

            <div className="prose max-w-none">
              <div className="bg-background-100 rounded-xl p-6 md:p-8 mb-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-4">品牌介绍</h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  「妈妈的朋友」是一个专注于影视内容分享与交流的中文平台。我们致力于为影视爱好者提供最新、最全面的影视资讯、深度影评和观影指南。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  平台成立于2024年，由一群热爱电影的资深影迷共同创建。我们相信，好的电影能够触动人心、启迪思考。通过专业的内容创作和社区交流，我们希望帮助更多人发现好电影，享受观影的乐趣。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  目前，平台已积累了超过50万注册用户，每日更新数十篇优质影视内容，涵盖电影推荐、影评解析、剧集追踪、经典回顾、影视资讯、观看指南等多个板块。
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">我们的优势</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {[
                    {
                      icon: 'ri-shield-check-line',
                      title: '专业可信',
                      desc: '由资深影评人和影视从业者组成的编辑团队，确保每一篇内容的专业性和可信度。',
                    },
                    {
                      icon: 'ri-timer-flash-line',
                      title: '及时更新',
                      desc: '紧跟影视行业动态，第一时间为读者带来最新上映信息和热门影评。',
                    },
                    {
                      icon: 'ri-user-heart-line',
                      title: '用户至上',
                      desc: '用心倾听每一位用户的反馈，不断优化内容质量和阅读体验。',
                    },
                  ].map((item) => (
                    <div
                      key={item.title}
                      className="p-5 rounded-xl bg-background-100 border border-background-200/70"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                        <i className={`${item.icon} text-lg`} />
                      </div>
                      <h3 className="text-base font-medium text-foreground-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">用户口碑</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {[
                    {
                      name: '王先生',
                      role: '影视爱好者',
                      comment:
                        '在妈妈的朋友平台上发现了很多冷门好片，影评质量很高，现在已经是我每天必刷的网站了。',
                      rating: 5,
                    },
                    {
                      name: '李女士',
                      role: '大学教师',
                      comment:
                        '非常专业的影视分析平台，文章深度和广度都很好，经常推荐给学生作为课外阅读材料。',
                      rating: 5,
                    },
                    {
                      name: '张同学',
                      role: '电影专业学生',
                      comment:
                        '这里的影评解析对我学习电影理论帮助很大，编辑团队的专业素养令人敬佩。',
                      rating: 5,
                    },
                    {
                      name: '陈先生',
                      role: '自由撰稿人',
                      comment:
                        '观影指南板块特别实用，帮我省去了很多找片的时间，推荐系统也很精准。',
                      rating: 4,
                    },
                  ].map((review) => (
                    <div
                      key={review.name}
                      className="p-5 rounded-xl bg-background-100 border border-background-200/70"
                    >
                      <div className="flex items-center gap-1 mb-3">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`text-sm ${
                              i < review.rating
                                ? 'ri-star-fill text-amber-400'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          />
                        ))}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                        "{review.comment}"
                      </p>
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                          <span className="text-xs font-medium text-secondary-700">
                            {review.name.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-900">
                            {review.name}
                          </p>
                          <p className="text-xs text-foreground-500">{review.role}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6 md:p-8">
                <h2 className="text-xl font-heading text-foreground-900 mb-4">联系我们</h2>
                <p className="text-foreground-700 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们会在24小时内回复您的消息。
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-mail-line" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm text-foreground-800">contact@mamadepengyou.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-customer-service-2-line" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">客服热线</p>
                      <p className="text-sm text-foreground-800">400-123-4567</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-map-pin-line" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">公司地址</p>
                      <p className="text-sm text-foreground-800">北京市朝阳区建国路88号影视大厦12层</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}